import {ActionTree, GetterTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'
import VueI18n from '../../helpers/i18n';
import store from '@/store'


import {filterQuery} from "@/helpers/filter";
import api from "@/service/api";
import shards from "@/store/modules/shards";


export interface State {
    isError:boolean,
    mailing: any[] | null,
    shards: any,
    shard: any,
    loading: boolean,
    loadShardStatus: boolean,
    loadShardStatusMerge: boolean,
    count: number,
    countShards: any,
    contactsStore: any,
    FilterShards: any,
    defFilterShards: any[],
    CurrentFilterShards: any[],
    countFiltersShards: number,
    defaultOptionTable: any,
    disableSearch: boolean,
    additionPaid: any,
}

const defaultState: State = {
    isError:false,
    mailing: null,
    disableSearch: false,
    defaultOptionTable: {page: 1, itemsPerPage: 20, sortBy: ['createdAtTimestamp'], sortDesc: [false]},
    shards: [],
    shard: {},
    loading: false,
    loadShardStatus: false,
    loadShardStatusMerge: false,
    count: 0,
    countShards: 0,
    contactsStore: null,
    CurrentFilterShards: [],
    defFilterShards: [
        {type: 'typeFilterFio', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'categoryFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'hotLevelFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'surveyFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'notesFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'typeContact', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'datePickerFilter', value: []},
        {type: 'isArchiveFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'search', value: ''},
        {type: 'options', value: {page: 1, itemsPerPage: 20, sortBy: ['createdAtTimestamp'], sortDesc: [false]}},
        {type: 'typeMailing', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'dataSourceTypes', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},

    ],
    FilterShards: [
        {type: 'typeFilterFio', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'categoryFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'hotLevelFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'surveyFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'notesFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'typeContact', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'datePickerFilter', value: []},
        {type: 'isArchiveFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'search', value: ''},
        {type: 'options', value: {page: 1, itemsPerPage: 20, sortBy: ['createdAtTimestamp'], sortDesc: [false]}},
        {type: 'typeMailing', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        {type: 'dataSourceTypes', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},

    ],
    countFiltersShards: 0,
    additionPaid: {}
};

const getters: GetterTree<State, RootState> = {

    defFilterShards: (state: State) => state.defFilterShards,
    isError: (state: State) => state.isError,
    mailing: (state: State) => state.mailing,
    disableSearch: (state: State) => state.disableSearch,
    getDefaultOptionTable: (state: State) => state.defaultOptionTable,
    getCurrentFilterShards: (state: State) => state.CurrentFilterShards,
    loading: (state: State) => state.loading,
    loadShardStatus: (state: State) => state.loadShardStatus,
    loadShardStatusMerge: (state: State) => state.loadShardStatusMerge,
    shards: (state: State) => state.shards,
    shard: (state: State) => state.shard,
    count: (state: State) => state.count,
    countShards: (state: State) => state.countShards,
    contactsStore: (state: State) => state.contactsStore,
    GetFilterShards: (state: State) => {
        VueI18n.locale = store.state.locale.locale

        return state.FilterShards
    },
    GetCountFiltersShards(state: State) {
        let count: number = 0
        if (state.FilterShards[0].value.filter((el: any) => {
            return el.id != 'all'
        }).length > 0) {
            count++
        }
        if (state.FilterShards[1].value.filter((el: any) => {
            return el.id != 'all'
        }).length > 0) {
            count++
        }
        if (state.FilterShards[2].value.filter((el: any) => {
            return el.id != 'all'
        }).length > 0) {
            count++
        }
        if (state.FilterShards[3].value.filter((el: any) => {
            return el.id != 'all'
        }).length > 0) {
            count++
        }
        if (state.FilterShards[4].value.filter((el: any) => {
            return el.id != 'all'
        }).length > 0) {
            count++
        }
        if (state.FilterShards[5].value.filter((el: any) => {
            return el.id != 'all'
        }).length > 0) {
            count++
        }
        if (state.FilterShards[6].value.filter((el: any) => {
            return el.id != 'all'
        }).length > 0) {
            count++
        }
        if (state.FilterShards[10].value.filter((el: any) => {
            return el.id != 'all'
        }).length > 0) {
            count++
        }
        if (state.FilterShards[11].value.filter((el: any) => {
            return el.id != 'all'
        }).length > 0) {
            count++
        }

        if (state.FilterShards[7].value.filter((el: any) => {
            return el.id != 'all'
        }).length > 0) {
            count++
        }
        return count
    },
    additionPaid: (state: State) => state.additionPaid,
}

const mutations: MutationTree<State> = {
    deleteShard(state: State,payload:any){
        state.shards = state.shards.filter((el:any)=>{return el.id !== payload})
    },
    patchShards(state: State,payload:any) {
        state.shards = state.shards.map((el:any)=>{
           if(el.id == payload.id){
               return payload
           }
           return el
       })

    },
    clearStore(state: State) {
        state.shards = []
        state.FilterShards = state.defFilterShards
        state.CurrentFilterShards = []
        const options = state.FilterShards[9]
        state.FilterShards = [
            {type: 'typeFilterFio', value: []},
            {type: 'categoryFilter', value: []},
            {type: 'hotLevelFilter', value: []},
            {type: 'surveyFilter', value: []},
            {type: 'notesFilter', value: []},
            {type: 'typeContact', value: []},
            {type: 'datePickerFilter', value: []},
            {type: 'isArchiveFilter', value: []},
            {type: 'search', value: ''},
            options,
            {type: 'typeMailing', value: []},
            {type: 'dataSourceTypes', value: []},
        ]
    },
    setDisableSearch(state: State, payload: boolean) {
        state.disableSearch = payload
    },
    setPageOne(state: State) {
        state.FilterShards[9].value.page = 1
    },
    setOptionsTableDefault(state: State) {
        state.FilterShards[9].value = state.defaultOptionTable
    },
    setOptionsTable(state: State, payload: object) {
        state.FilterShards[9].value = payload
    },
    clearSearch(state: State) {
        state.FilterShards[8].value = ''
        state.FilterShards[9].value.page = 1
    },
    setCurrentFilterShards(state: State) {
        state.CurrentFilterShards = JSON.parse(JSON.stringify(state.FilterShards))
    },
    setAttributes(state: State, payload: any) {
        state.shards = state.shards.map((shard: any) => {
            return (shard.id == payload.id) ? payload : shard
        })
    },
    setShards(state: State, payload: any[]) {
        state.shards = payload
    },
    setShard(state: State, payload: any[]) {
        state.shard = payload
    },
    openEditShard(state: State,payload:any) {
        if(payload.type === 'location'){
            state.shard.contactBlock.locations.forEach((location:any)=>{
                if(location.id === payload.id) {
                    location.edit = true
                }
            })
        }else {
            state.shard.contactBlock.contacts.forEach((contact:any)=>{
                if(contact.id === payload.id){
                    contact.edit = true
                }
            })
        }
    },
    closeEditeShard(state: State,payload:any) {

        if(payload.type === 'location'){
            state.shard.contactBlock.locations.forEach((location:any)=>{
                if(location.id === payload.id){
                    location.edit = false
                }
            })
        }else {
            state.shard.contactBlock.contacts.forEach((contact:any)=>{
                if(contact.id === payload.id) {
                    contact.edit = false
                }
            })
        }

    },
    setLoadStatus(state: State, payload: boolean) {
        state.loading = payload
    },
    setLoadShardStatus(state: State, payload: boolean) {
        state.loadShardStatus = payload
    },
    setCount(state: State, payload: number) {
        state.count = payload
    },
    setError(state: State, payload: boolean) {
        state.isError = payload
    },
    setCountShards(state: State, payload: any) {
        state.countShards = payload
    },
    setContact(state: State, payload: any) {
        state.shard.contactBlock.contacts.push(payload)
    },
    deleteContact(state: State, payload: string) {
        state.shard.contactBlock.contacts = state.shard.contactBlock.contacts.filter((contact: any) => contact.id != payload)
    },
    setLocation(state: State, payload: any) {
        payload.type = 'location'
        state.shard.contactBlock.locations.push(payload)
    },
    deleteLocation(state: State, payload: string) {
        state.shard.contactBlock.locations = state.shard.contactBlock.locations.filter((location: any) => location.id != payload)
    },
    setContactsStore(state: State, payload: any[]) {
        state.contactsStore = payload
    },
    setMediaAttachment(state: State, payload: any) {
        state.shard.mediaAttachments.forEach((media: any) => {
            if (media.id == payload.params.id) {
                media.text = payload.body.text
            }
        })
    },
    deleteDataSource(state: State, payload: any) {
        state.shards.forEach((shard: any) => {
            if (shard.id == payload.shardId) {
                shard.dataSources = shard.dataSources.filter((elem: any) => elem.id != payload.noteId)
            }
        })
        state.shard.dataSources = state.shard.dataSources.filter((elem: any) => elem.id != payload.noteId)
    },
    deleteMediaAttachment(state: State, payload: any) {
        state.shard.mediaAttachments = state.shard.mediaAttachments.filter((elem: any) => elem.id != payload.params.id)
    },
    setCurrentFilterShardsDef(state: State) {
        state.FilterShards =  [
            {type: 'typeFilterFio', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
            {type: 'categoryFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
            {type: 'hotLevelFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
            {type: 'surveyFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
            {type: 'notesFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
            {type: 'typeContact', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
            {type: 'datePickerFilter', value: []},
            {type: 'isArchiveFilter', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
            {type: 'search', value: ''},
            {type: 'options', value: {page: 1, itemsPerPage: 20, sortBy: ['createdAtTimestamp'], sortDesc: [false]}},
            {type: 'typeMailing', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
            {type: 'dataSourceTypes', value: [{id: 'all', text: VueI18n.t('newShardList.filter.hotLevel.all')}]},
        ]
    },
    setFilterShards(state: State, payload: any) {
        state.FilterShards.filter((ele: any) => {
            return ele.type == payload.type
        })[0].value = [] = payload.value
    },
    clearFilterShards(state: State) {

        const search = state.FilterShards[8]
        const options = state.FilterShards[9]

        try {
      state.FilterShards =[
          {type: 'typeFilterFio', value: []},
          {type: 'categoryFilter', value: []},
          {type: 'hotLevelFilter', value: []},
          {type: 'surveyFilter', value: []},
          {type: 'notesFilter', value: []},
          {type: 'typeContact', value: []},
          {type: 'datePickerFilter', value: []},
          {type: 'isArchiveFilter', value: []},
          search,
          options,
          {type: 'typeMailing', value: []},
          {type: 'dataSourceTypes', value: []},
      ]

        }catch (e) {
            console.log(e.message)
        }
    },
    setAdditionPaid(state: State, payload: any) {
        state.additionPaid = payload
    },
    setNewNoteByShard(state: State, payload: any){
       state.shard.mediaAttachments.push(payload)

    }
}

const actions: ActionTree<State, RootState> = {
    async addNotePersonal({commit, state}, payload: any) {
        commit('setLoadStatus', true)
        try {
            const {data} = await api.go('addNotePersonal', {
                params: payload.params,
                body:payload.body
            })
            commit('setNewNoteByShard',data.data)

        }catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
        }finally {
            commit('setLoadStatus', false)
        }
    },    async addNoteCompany({commit, state}, payload: any) {
        commit('setLoadStatus', true)
        try {
            const {data} = await api.go('addNoteCompany', {
                params: payload.params,
                body:payload.body
            })
            commit('setNewNoteByShard',data.data)

        }catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
        }finally {
            commit('setLoadStatus', false)
        }
    },
    async loadShardsFromServerPersonal({commit, state}, payload: any) {
        try {
            const {data} = await api.go('getPersonalShards', {params: payload})
            if (data.error) {
                throw (data.error)
            }
            commit('setShards', data.data.models)
            commit('setCount', data.data.allCount)
            commit('setLoadStatus', false)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
            commit('setLoadStatus', false)
        }
    },
    async loadShardsFromServerPersonalWithQuery({commit, state}, payload: any) {
        commit('setLoadStatus', true)
        commit('setDisableSearch', true)
        payload.query = filterQuery(state.FilterShards);
        try {
            const {data} = await api.go('getPersonalShards', {params: payload})
            if (data.error) {
                throw (data.error)
            }
            commit('setShards', data.data.models)
            commit('setCount', data.data.allCount)
            commit('setLoadStatus', false)
            commit('setDisableSearch', false)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
            commit('setLoadStatus', false)
        }
    },
    async loadShardsFromServerCompany({commit, state}, payload: any) {
        commit('setLoadStatus', true)
        payload.query = ''
        try {
            const {data} = await api.go('getCompanyShards', payload)
            if (data.error) {
                throw (data.error)
            }
            commit('setShards', data.data.models)
            commit('setCount', data.data.allCount)
            commit('setLoadStatus', false)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
            commit('setLoadStatus', false)
        }
    },

    async getStatisticsSummary({commit, state}, payload: any) {
        // commit('setLoadStatus', true)
        try {
            const {data} = await api.go('getStatisticsSummary', payload)
            if (data.error) {
                throw (data.error)
            }
            state.mailing =data.data
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)

        }
    },
    async loadShardsFromServerCompanyByMailing({commit, state}, payload: any) {
        commit('setLoadStatus', true)
        try {
            const {data} = await api.go('getCompanyShardsByMailing', payload)
            if (data.error) {
                throw (data.error)
            }
            commit('setShards', data.data.models)
            commit('setCount', data.data.allCount)

        } catch (e) {
            this.commit('setError', true)
            console.log(e.message)

        }finally
        {
            commit('setLoadStatus', false)
        }
    },
    async updateSendEmail({commit, state}, payload: any) {
        commit('setLoadStatus', true)
        try {
            const {data} = await api.go('updateSendEmail', payload)
            if (data.error) {
                throw (data.error)
            }
            commit('deleteShard', payload.params.idShard)
            this.commit('alerts/setAlert', {
                show: true,
                messages:[VueI18n.t('newShardList.mailing.update')]
            })

        } catch (e) {
            this.commit('setError', true)
            console.log(e.message)

        }finally
        {
            commit('setLoadStatus', false)
        }
    },
    async loadShardsFromServerCompanyWithQuery({commit, state}, payload: any) {
        commit('setLoadStatus', true)
        commit('setDisableSearch', true)
        payload.query = filterQuery(state.FilterShards) + `onlyOwner=${payload.onlyOwner}&`;
        try {
            const {data} = await api.go('getCompanyShards', {params: payload})
            if (data.error) {
                throw (data.error)
            }
            commit('setShards', data.data.models)
            commit('setCount', data.data.allCount)
            commit('setLoadStatus', false)
            commit('setDisableSearch', false)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
            commit('setLoadStatus', false)
        }
    },
    async loadShardFromServerPersonal({commit, state}, payload: any) {
        commit('setLoadShardStatus', true)
        try {
            const {data} = await api.go('getPersonalShard', {params: payload})
            if (data.error) {
                throw (data.error)
            }
            data.data.contactBlock.contacts.forEach((contact: any) => {
                contact.edit = false
                contact.editType = false
            })
            data.data.contactBlock.locations.forEach((location: any) => {
                location.edit = false
                location.editType = false
                location.type = 'location'
            })
            data.data.dataSources.forEach((source: any) => {
                source.select = false
            })
            data.data.mediaAttachments.forEach((media: any) => {
                if (media.type == 'voice') {
                    media.play = false;
                    media.mute = false;
                }
            })
            commit('setShard', data.data)
            commit('setLoadShardStatus', false)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            console.log(e.message)
            commit('setLoadShardStatus', false)
        }
    },
    async loadShardFromServerCompany({commit, state}, payload: any) {
        try {
            commit('setLoadShardStatus', true)
            const {data} = await api.go('getCompanyShard', {params: payload})
            if (data.error) {
                throw (data.error)
            }
            data.data.contactBlock.contacts.forEach((contact: any) => {
                contact.edit = false
                contact.editType = false
            })
            data.data.contactBlock.locations.forEach((location: any) => {
                location.edit = false
                location.editType = false
                location.type = 'location'
            })
            data.data.dataSources.forEach((source: any) => {
                source.select = false
            })
            data.data.mediaAttachments.forEach((media: any) => {
                if (media.type == 'voice') {
                    media.play = false;
                    media.mute = false;
                }
            })
            commit('setShard', data.data)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e.message]
            })

        }finally {
            commit('setLoadShardStatus', false)
        }
    },
    async loadShardFromServerCompanyMerge({commit, state}, payload: any) {
        try {
            state.loadShardStatusMerge = true
            const {data} = await api.go('getCompanyShard', {params: payload})
            if (data.error) {
                throw (data.error)
            }
            data.data.contactBlock.contacts.forEach((contact: any) => {
                contact.edit = false
                contact.editType = false
            })
            data.data.contactBlock.locations.forEach((location: any) => {
                location.edit = false
                location.editType = false
                location.type = 'location'
            })
            data.data.dataSources.forEach((source: any) => {
                source.select = false
            })
            data.data.mediaAttachments.forEach((media: any) => {
                if (media.type == 'voice') {
                    media.play = false;
                    media.mute = false;
                }
            })
            commit('setShard', data.data)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e.message]
            })

        }finally {
            state.loadShardStatusMerge = false
        }
    },
    async saveShardFromServerPersonal({commit, state}, payload: any) {
        try {
            const {data} = await api.go('patchPersonalShards', {params: payload.params, body: payload.body})
            data.data.contactBlock.contacts.forEach((contact: any) => {
                contact.edit = false
                contact.editType = false
            })
            data.data.contactBlock.locations.forEach((location: any) => {
                location.edit = false
                location.editType = false
                location.type = 'location'
            })
            data.data.dataSources.forEach((source: any) => {
                source.select = false
            })
            data.data.mediaAttachments.forEach((media: any) => {
                if (media.type == 'voice') {
                    media.play = false;
                }
            })
            commit('setAttributes', data.data)
            commit('setShard', data.data)
        } catch (e) {
        }
    },
    async loadShardFromServerPersonalMerge({commit, state}, payload: any) {
        try {
            state.loadShardStatusMerge = true
            const {data} = await api.go('patchPersonalShards', {params: payload.params, body: payload.body})
            data.data.contactBlock.contacts.forEach((contact: any) => {
                contact.edit = false
                contact.editType = false
            })
            data.data.contactBlock.locations.forEach((location: any) => {
                location.edit = false
                location.editType = false
                location.type = 'location'
            })
            data.data.dataSources.forEach((source: any) => {
                source.select = false
            })
            data.data.mediaAttachments.forEach((media: any) => {
                if (media.type == 'voice') {
                    media.play = false;
                }
            })
            commit('setAttributes', data.data)
            commit('setShard', data.data)
        } catch (e) {
        }finally {
            state.loadShardStatusMerge = false
        }
    },
    async saveShardFromServerCompany({commit, state}, payload: any) {
        try {
            const {data} = await api.go('patchCompanyShards', {params: payload.params, body: payload.body})
            data.data.contactBlock.contacts.forEach((contact: any) => {
                contact.edit = false
                contact.editType = false
            })
            data.data.contactBlock.locations.forEach((location: any) => {
                location.edit = false
                location.editType = false
                location.type = 'location'
            })
            data.data.dataSources.forEach((source: any) => {
                source.select = false
            })
            data.data.mediaAttachments.forEach((media: any) => {
                if (media.type == 'voice') {
                    media.play = false;
                }
            })
            commit('setAttributes', data.data)
            commit('setShard', data.data)
        } catch (e) {
        }
    },
    async editContactFromServerCompany({commit, state}, payload: any) {
        try {
           await api.go('patchCompanyContact', {params: payload.params, body: payload.body})
        } catch (e) {
        }
    },
    async deleteContactFromServerCompany({commit, state}, payload: any) {
        try {
           await api.go('deleteCompanyContact', {params: payload.params})
            commit('deleteContact', payload.params.contactId)
        } catch (e) {
        }
    },
    async editContactFromServerPersonal({commit, state}, payload: any) {
        try {
           await api.go('patchPersonalContact', {params: payload.params, body: payload.body})
        } catch (e) {
        }
    },
    async deleteContactFromServerPersonal({commit, state}, payload: any) {
        try {
          await api.go('deletePersonalContact', {params: payload.params})
            commit('deleteContact', payload.params.contactId)
        } catch (e) {
        }
    },
    async addContactFromServerCompany({commit, state}, payload: any) {
        try {
            const {data} = await api.go('addCompanyContact', {params: payload.params, body: payload.body})
            data.data.edit = false
            data.data.editType = false
            commit('setContact', data.data)
        } catch (e) {
        }
    },
    async addContactFromServerPersonal({commit, state}, payload: any) {
        try {
            const {data} = await api.go('addPersonalContact', {params: payload.params, body: payload.body})
            data.data.edit = false
            data.data.editType = false
            commit('setContact', data.data)
        } catch (e) {
        }
    },
    async editLocationFromServerCompany({commit, state}, payload: any) {
        try {
           await api.go('patchCompanyLocation', {params: payload.params, body: payload.body})
        } catch (e) {
        }
    },
    async deleteLocationFromServerCompany({commit, state}, payload: any) {
        try {
           await api.go('deleteCompanyLocation', {params: payload.params})
            commit('deleteLocation', payload.params.locationId)
        } catch (e) {
        }
    },
    async editLocationFromServerPersonal({commit, state}, payload: any) {
        try {
           await api.go('patchPersonalLocation', {params: payload.params, body: payload.body})
        } catch (e) {
        }
    },
    async deleteLocationFromServerPersonal({commit, state}, payload: any) {

        try {
          await api.go('deletePersonalLocation', {params: payload.params})
            commit('deleteLocation', payload.params.locationId)
        } catch (e) {
        }
    },
    async addLocationFromServerCompany({commit, state}, payload: any) {

        try {
            const {data} = await api.go('addCompanyLocation', {params: payload.params, body: payload.body})
            data.data.edit = false
            data.data.editType = false
            commit('setLocation', data.data)
        } catch (e) {
        }
    },
    async addLocationFromServerPersonal({commit, state}, payload: any) {
        try {
            const {data} = await api.go('addPersonalLocation', {params: payload.params, body: payload.body})
            data.data.edit = false
            data.data.editType = false
            commit('setLocation', data.data)
        } catch (e) {
        }
    },
    async editMediaAttachmentFromServerCompany({commit, state}, payload: any) {
        try {
           await api.go('patchCompanyMedia', {params: payload.params, body: payload.body})
            commit('setMediaAttachment', payload)
        } catch (e) {
        }
    },
    async editMediaAttachmentFromServerPersonal({commit, state}, payload: any) {
        try {
           await api.go('patchPersonalMedia', {params: payload.params, body: payload.body})
            commit('setMediaAttachment', payload)
        } catch (e) {
        }
    },
    async deleteMediaAttachmentFromServerCompany({commit, state}, payload: any) {
        try {
           await api.go('deleteCompanyMedia', {params: payload.params})
            commit('deleteMediaAttachment', payload)
        } catch (e) {
        }
    },
    async deleteMediaAttachmentFromServerPersonal({commit, state}, payload: any) {
        try {
          await api.go('deletePersonalMedia', {params: payload.params})
            commit('deleteMediaAttachment', payload)
        } catch (e) {
        }
    },
    async getAdditionPaid({commit, state}, payload: any) {
        try {
            const {data} = await api.go('getAdditionPaid', {params: payload})
            commit('setAdditionPaid', data)
        } catch (e) {
        }
    },
    async getCountShards({commit, state}, payload: any) {
        try {
            const {data} = await api.go('getCountShards', {params: payload})
            commit('setCountShards', data)
        } catch (e) {
        }
    },
    async exportAllShardsCompany({commit, state}, payload: any) {
        try {
            if(payload.helper == 'filter'){
                let obj:any = payload.query
                const help = filterQuery(state.FilterShards).split('&').map((el:any)=>{
                    let index = el.split('=')[0]
                    if(index && el.split('=')[0] != undefined){
                        if(index == 'page') return
                        if(index == 'per-page') return
                        if(index == 'sort') return
                        obj[index] = el.split('=')[1]
                    }
                })

                payload.query = obj
            }

            await api.go('exportAllShardsCompany', {
                query: payload.query,
                params: payload.params,
                body: payload.body
            })
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [payload.message]
            })
            return true
        } catch (e) {
            return false
        }
    },
    async exportOneShardsCompany({commit, state}, payload: any) {
        try {
            await api.go('exportOneShardsCompany', {params: payload.params, body: payload.body})
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [payload.message]
            })
            return true
        } catch (e) {
            return false
        }
    },
    async exportAllShardsPersonal({commit, state}, payload: any) {
        try {
            await api.go('exportAllShardsPersonal', {
                query: payload.query,
                params: payload.params,
                body: payload.body
            })
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [payload.message]
            })
            return true
        } catch (e) {
            return false
        }
    },
    async exportOneShardsPersonal({commit, state}, payload: any) {
        try {
            await api.go('exportOneShardsPersonal', {params: payload.params, body: payload.body})
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [payload.message]
            })
            return true
        } catch (e) {
            return false
        }
    },
}

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
}
